import { createSlice } from "@reduxjs/toolkit";
import {getStudyabroadIdpStatusRepo, postStudyabroadIdpRepo} from '../../repositories/studyabroad'

const studyabroadFormlSlice = createSlice({
  name: "studyabroadFormreducer",
  initialState: {
    studyabroadIdpLoading: null,
    studyabroadIdpSuccess: null,
    studyabroadIdpError: null,

    postStudyabroadIdpSuccess: null,
    postStudyabroadIdpError: null,  
  },

  reducers: {
    getStudyabroadIdpLoading(state, action) {
      return {
        ...state,
        studyabroadIdpLoading: true,
      };
    },
    getStudyabroadIdpSuccess(state, action) {
      return {
        ...state,
        studyabroadIdpLoading: false,
        studyabroadIdpSuccess: action.payload,
      };
    },
    getStudyabroadIdpFailure(state, action) {
      return {
        ...state,
        studyabroadIdpLoading: false,
        studyabroadIdpError: action.payload,
      };
    },

    clearStudyabroadIdpResponse(state, action) {
      return {
        ...state,
        studyabroadIdpSuccess: null,
      };
    },

    postStudyabroadIdpSuccess(state, action) {
      return {
        ...state,
        postStudyabroadIdpSuccess: action.payload,
      };
    },
    postStudyabroadIdpFailure(state, action) {
      return {
        ...state,
        postStudyabroadIdpError: action.payload,
      };
    },
  },
});

export const {
  getStudyabroadIdpLoading,
  getStudyabroadIdpSuccess,
  getStudyabroadIdpFailure,
  clearStudyabroadIdpResponse,
  postStudyabroadIdpSuccess,
  postStudyabroadIdpFailure,
} = studyabroadFormlSlice.actions;

export const getStudyabroadIdp = (params) => {
  return async (dispatch) => {
    await getStudyabroadIdpStatusRepo(params)
      .then((response) => {
        if (response.status === 200) {
          dispatch(getStudyabroadIdpSuccess(response?.data));
        } else {
          dispatch(getStudyabroadIdpFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getStudyabroadIdpFailure(error.message));
        }
      });
  };
};

export const postStudyabroadIdp = (data) => {
  return async (dispatch) => {
    await postStudyabroadIdpRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch(postStudyabroadIdpSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postStudyabroadIdpFailure(error.message));
        }
      });
  };
};

export default studyabroadFormlSlice.reducer;
